import axios from '@axios'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function usePaymentContract() {
  // Use toast
  const toast = useToast()

  const updateApplicationPaymentOption = queryParams => axios
    .put(`/auth/application-pay-conditions/${queryParams.id}`, queryParams)
    .then(response => {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Successful pause payments',
          icon: 'ThumbsUpIcon',
          variant: 'info',
        },
      })
      return response.data.data
    })
    .catch(() => toast({
      component: ToastificationContent,
      props: {
        title: 'Payments pause error',
        icon: 'AlertTriangleIcon',
        variant: 'danger',
      },
    }))

  const updateApplicationPayConditionTransaction = queryParams => axios
    .put(`/auth/pay-condition-transactions/${queryParams.id}`, queryParams)
    .then(response => {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Successful pause payments',
          icon: 'ThumbsUpIcon',
          variant: 'info',
        },
      })
      return response.data.data
    })
    .catch(() => toast({
      component: ToastificationContent,
      props: {
        title: 'Payments pause error',
        icon: 'AlertTriangleIcon',
        variant: 'danger',
      },
    }))

  return {
    updateApplicationPaymentOption,
    updateApplicationPayConditionTransaction,
  }
}
